export default __webpack_public_path__ + "static/media/KPI.ec85c099.jpg";